export const IMAGES = {
  heroPrism:
    "https://images.unsplash.com/photo-1743046813915-94cf6d5e6942?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHdoaXRlJTIwYmFja2dyb3VuZCUyMHN1YnRsZSUyMHZpb2xldCUyMGxpZ2h0JTIwbGVha3xlbnwwfHx8fDE3ODQ1NjUwNDF8MA&ixlib=rb-4.1.0&q=85",
  portrait: "/dr-bairbre-fee.png",
  therapyRoom:
    "https://images.pexels.com/photos/12422453/pexels-photo-12422453.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  parentChild:
    "https://images.unsplash.com/photo-1576696058573-12b47c49559e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxwYXJlbnQlMjBhbmQlMjBjaGlsZCUyMGNvbm5lY3Rpb24lMjB3YXJtJTIwbGlnaHR8ZW58MHx8fHwxNzg0NjUxODkxfDA&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Approach", id: "approach" },
  { label: "Events", id: "events" },
  { label: "Book", id: "booking" },
];

// Vibrant spectrum drawn from the Prism logo — used as accents across the site.
export const PRISM = [
  "#E0619B", // pink
  "#F0862F", // orange
  "#2FD6B8", // teal
  "#38A4E0", // blue
  "#B13FD0", // magenta
];
